/**
 * Mirrors packages/amghighlow_v2/lib/presentation/rive/rive_inputs.dart
 */

export const MainInputs = {
  stateMachine: 'Main',
  // triggers
  trigGirlAnim: 'girl',
  trigShuffle: 'triCardShuffle',
  trigCardReset: 'cardReset',
  trigLowButton: 'triLowButton',
  trigHighButton: 'triHighButton',
  trigPlayCard6: 'card6Continues',
  // numbers
  numGirlAnim: 'GirlAnim', // 0=init, 1=lets play, 2=take chip
  numCardPlay: 'intcardPLay', // 0..6 (0=reset, 1..6=card slot)
  // booleans
  boolYellowPointer: 'boolYellowPointer',
  boolIsSound: 'isSounOn',
  // Card faces: ONE reusable `CardFace` artboard whose number input `CardType`
  // selects the face, instanced at six nested slot PATHS `CardFace1`..`CardFace6`
  // (round1 start/result, round2 …). Reveal a slot via
  //   setNumberStateAtPath(input: cardTypeInput, value, path: cardSlotN)
  // i.e. input=`CardType`, path=`CardFaceN` — NOT the other way round.
  cardSlot1: 'CardFace1',
  cardSlot2: 'CardFace2',
  cardSlot3: 'CardFace3',
  cardSlot4: 'CardFace4',
  cardSlot5: 'CardFace5',
  cardSlot6: 'CardFace6',
  cardTypeInput: 'CardType',
} as const;

export const BettingInputs = {
  stateMachine: 'Main',
  boolIsSound: 'isSounOn',
} as const;

export const RiveEvents = {
  evtClickChips: 'evtClickChips',
  evtSoundOnOff: 'evtSoundOnOff',
  evtMusicOnOff: 'evtMusicOnOff',
  evtClearClick: 'evtClearClick',
  evtButtonPlayClick: 'evtButtonPlayClick',
  placeBetClick: 'placeBetClick',
  UIButtonClick: 'UIButtonClick',
  sideAnimWin: 'sideAnimWin',
  evtResultStop: 'evtResultStop',
} as const;
